export default {
  general: {
    invalid: "TXT_ERROR_Form_General_Invalid"
  },
  fields: {
    email: {
      isRequired: "TXT_ERROR_Form_Email_Missing",
      isEmail: "TXT_ERROR_Form_Email_Invalid"
    },
    nameEN: {
      isRequired: "TXT_ERROR_Form_Name_EN_Missing",
      isCompanyNameEN: "TXT_ERROR_Form_Name_EN_Invalid"
    },
    nameTC: {
      isCompanyNameTC: "TXT_ERROR_Form_Name_TC_Invalid"
    },
    nameSC: {
      isCompanyNameSC: "TXT_ERROR_Form_Name_SC_Invalid"
    },
    contactPerson: {
      isRequired: "TXT_ERROR_Form_Contact_Person_Missing",
      isFirstName: "TXT_ERROR_Form_Contact_Person_FN_Invalid",
      isLastName: "TXT_ERROR_Form_Contact_Person_LN_Invalid"
    },
    telephone: {
      isRequired: "TXT_ERROR_Form_Telephone_Field_Missing",
      isPhoneNumber: "TXT_ERROR_Form_Telephone_Number_Invalid",
      isAreaCodeNumber: "TXT_ERROR_Form_Telephone_Area_Cod_Invalid",
      isExtensionNumber: "TXT_ERROR_Form_Telephone_Ext_Invalid"
    },
    address: {
      isRequired: "TXT_ERROR_Form_Address_Missing",
      isFirstRow: "TXT_ERROR_Form_Address_First_Row_Invalid",
      isSecondRow: "TXT_ERROR_Form_Address_Second_Row_Invalid",
      isThirdRow: "TXT_ERROR_Form_Address_Third_Row_Invalid",
      isFourthRow: "TXT_ERROR_Form_Address_Fourth_Row_Invalid"
    },
    region: {
      country: { isRequired: "TXT_ERROR_Form_Region_Country_Missing" },
      state: { isAssociated: "TXT_ERROR_Form_Region_Mandatory_State_Missing" },
      city: { isAssociated: "TXT_ERROR_Form_Region_Mandatory_City_Missing" }
    },
    natureOfBusiness: {
      isRequired: "TXT_ERROR_Form_NOB_Missing"
    },
    emailLangPef: {
      isRequired: "TXT_ERROR_Form_Email_Lang_Pref"
    },
    saleRepCode: {
      isSaleRepCode: "TXT_ERROR_Form_Sales_Rep_Code_Invalid"
    },
    BRDetails: {
      number: {
        isAssociated: "TXT_ERROR_Form_BR_Number_Missing",
        isHKBRNumber: "TXT_ERROR_Form_HKBR_Number_Invalid",
        isNotHKBRNumber: "TXT_ERROR_Form_NOT_HKBR_Number_Invalid"
      },
      commencementDate: {
        isAssociated: "TXT_ERROR_Form_BR_Commencement_Date_Missing"
      },
      expiryDate: {
        isAssociated: "TXT_ERROR_Form_BR_Expiry_Date_Missing"
      },
      file: {
        isAssociated: "TXT_ERROR_Form_BR_Image_Missing"
      }
    }
  }
}
